import { render, staticRenderFns } from "./editScheduleNotification.vue?vue&type=template&id=c156854e&scoped=true&"
import script from "./editScheduleNotification.vue?vue&type=script&lang=js&"
export * from "./editScheduleNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c156854e",
  null
  
)

export default component.exports